import { createSlice } from '@reduxjs/toolkit';
import { ApiSignalType } from 'src/features/Signals/types';

export type SignalsStateType = {
  items: Array<ApiSignalType>;
  signalDetails: ApiSignalType | null;
  status: 'idle' | 'pending' | 'failed' | 'succeeded';
  meta: {
    page: number;
    total: number;
    next: null | string;
  };
};

const initialState: SignalsStateType = {
  items: [],
  signalDetails: null,
  status: 'idle',
  meta: {
    page: 1,
    total: 0,
    next: null,
  },
};

const signalsSlice = createSlice({
  name: 'signals',
  initialState,
  reducers: {
    fetchSignals: (state, action) => {
      if (!action.payload.items || !action.payload.items.length) return;

      state.items = action.payload.items;
      state.meta.total = action.payload.total;
      state.status = 'succeeded';
    },
    setSignalDetails: (state, action) => {
      if (!action.payload) return;

      state.signalDetails = action.payload;
    },
    changeStatus: (state, action) => {
      if (!action.payload.item) return;

      state.status = action.payload.item;
    },
  },
});

export default signalsSlice.reducer;

export const {
  fetchSignals: fetchSignalsAction,
  setSignalDetails: setSignalDetailsAction,
  changeStatus: changeStatusAction,
} = signalsSlice.actions;
